export class PrintObject {
  id: number | undefined;
  objectID: string;
  title: string;
  parentID: string;
  sortIndexInParent: number;

  // Will be true if topic is valid for current variant filter
  inActiveFilter!: boolean;

  constructor(objectID: string, title: string, parentID: string = "", sortIndexInParent: number = 0, sortIndex: number = 0, printObjectId: number | undefined = undefined) {
    this.objectID = objectID;
    this.title = title;
    this.parentID = parentID;
    this.sortIndexInParent = sortIndexInParent;
    this.id = printObjectId;
  }
}
